import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import FlatButton from 'material-ui/FlatButton'
import { ActionList } from 'material-ui/svg-icons'
import LoadingSpinner from '../../sitewide/Spinner'
import MessageSettingApptTypePicker from '../MessageSettingApptTypePicker'
import { ATReduce, selectedApptTypesById, equalArrays } from '../utils'
import './styles.css'

class ApptTypeSelector extends Component {
  constructor(props) {
    super(props)
    const { usedAppointmentTypeIds } = props
    this.state = {
      apptTypeIdsToPost: usedAppointmentTypeIds,
      searchTerm: '',
      selectorOpen: false,
    }
  }

  componentWillReceiveProps({
    activeLocation,
    usedAppointmentTypeIds: apptTypeIdsToPost,
  }) {
    const { usedAppointmentTypeIds, activeLocation: lastLocation } = this.props
    const hasChanges =
      !equalArrays(usedAppointmentTypeIds, apptTypeIdsToPost) ||
      (activeLocation && lastLocation.id !== activeLocation.id)
    if (hasChanges) {
      this.setState({
        apptTypeIdsToPost,
      })
    }
  }

  toggleSelector = (isOpen) => {
    this.setState({ selectorOpen: isOpen })
  }

  handleCancel = () => {
    const { usedAppointmentTypeIds } = this.props
    this.setState({
      apptTypeIdsToPost: usedAppointmentTypeIds,
    })
    this.toggleSelector(false)
  }

  handleSubmit = () => {
    const { apptTypeIdsToPost } = this.state
    const { updateSetting } = this.props
    this.toggleSelector(false)
    updateSetting(null, apptTypeIdsToPost)
  }

  handleAddType = (addId) => {
    const { apptTypeIdsToPost } = this.state
    if (apptTypeIdsToPost.includes(addId)) return false
    this.setState({
      apptTypeIdsToPost: [...apptTypeIdsToPost, addId],
    })
  }

  handleRemoveType = (removeId) => {
    const { apptTypeIdsToPost } = this.state
    const filteredTypes = apptTypeIdsToPost.filter(
      typeId => typeId !== removeId,
    )
    this.setState({ apptTypeIdsToPost: filteredTypes })
  }

  handleSearch = e => this.setState({ searchTerm: e.target.value })

  toggleAllTypes = () => {
    const { apptTypeIdsToPost } = this.state
    const { appointmentTypes, updateSetting } = this.props

    const allTypesSelected =
      apptTypeIdsToPost.length === appointmentTypes.length
    const newTypes = allTypesSelected
      ? []
      : appointmentTypes.map(type => type.id)
    updateSetting(null, newTypes)
  }

  render() {
    const {
      appointmentTypes,
      appointmentTypesById,
      isLoaded,
      usedAppointmentTypeIds,
    } = this.props

    const { apptTypeIdsToPost, searchTerm, selectorOpen } = this.state

    const actions = [
      <FlatButton label="Cancel" primary onClick={() => this.handleCancel()} />,
      <FlatButton
        label="Submit"
        primary
        disabled={!apptTypeIdsToPost.length}
        onClick={() => this.handleSubmit()}
      />,
    ]

    const availableAppointmentTypesById = appointmentTypes
      .filter(({ id }) => !usedAppointmentTypeIds.includes(id))
      .reduce(ATReduce, {})

    const availableAppointmentTypeIds = Object.keys(
      availableAppointmentTypesById,
    )

    const allTypesSelected =
      appointmentTypes.length === apptTypeIdsToPost.length

    return (
      <div>
        {isLoaded ? (
          <div className="apptButtonContainer">
            <button
              className={'button'}
              onClick={() => this.toggleSelector(true)}
            >
              <ActionList />
              <span>{`Choose Appointment Types (${usedAppointmentTypeIds.length})`}</span>
            </button>
            <button
              className={`button toggleButton ${
                allTypesSelected ? 'remove' : ''
              }`}
              onClick={() => this.toggleAllTypes()}
            >
              {`${allTypesSelected ? 'Remove' : 'Add'} all types`}
            </button>
            <MessageSettingApptTypePicker
              actions={actions}
              handleAddType={this.handleAddType}
              handleRemoveType={this.handleRemoveType}
              handleSearch={this.handleSearch}
              listType="Appointment Types"
              open={selectorOpen}
              searchTerm={searchTerm}
              selectedTypes={apptTypeIdsToPost}
              sliderAppointmentTypeIds={[
                ...availableAppointmentTypeIds,
                ...usedAppointmentTypeIds,
              ]}
              sliderAppointmentTypes={{
                ...availableAppointmentTypesById,
                ...selectedApptTypesById(
                  usedAppointmentTypeIds,
                  appointmentTypesById,
                ),
              }}
              showSliderNameInput={false}
            />
          </div>
        ) : (
          <LoadingSpinner />
        )}
      </div>
    )
  }
}

const mapStateToProps = ({
  account: {
    user: { activeLocation },
  },
  appointmentTypes: { appointmentTypes },
  messageSettings: { isLoaded },
}) => {
  const appointmentTypesById = appointmentTypes.reduce(ATReduce, {})

  return {
    activeLocation,
    isLoaded,
    appointmentTypes,
    appointmentTypesById,
  }
}

ApptTypeSelector.propTypes = {
  activeLocation: PropTypes.shape({
    active: PropTypes.bool.isRequired,
    additional_recipients: PropTypes.arrayOf(PropTypes.object),
    city: PropTypes.string,
    country_code: PropTypes.string,
    created_at: PropTypes.string,
    doctor_id: PropTypes.string,
    earliest_same_day_reminder_hour: PropTypes.number,
    facebook_url: PropTypes.string,
    forwarding_email: PropTypes.string,
    google_url: PropTypes.string,
    id: PropTypes.string,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    name: PropTypes.string,
    office_email: PropTypes.string,
    office_phone: PropTypes.string,
    phone_numbers: PropTypes.arrayOf(PropTypes.object),
    practice_id: PropTypes.number,
    state: PropTypes.string,
    street_address: PropTypes.string,
    timezone: PropTypes.string,
    updated_at: PropTypes.string,
    website: PropTypes.string,
    yelp_url: PropTypes.string,
    zip: PropTypes.string,
  }),
  appointmentTypes: PropTypes.arrayOf(PropTypes.object).isRequired,
  appointmentTypesById: PropTypes.objectOf(
    PropTypes.shape({
      id: PropTypes.string,
    }),
  ).isRequired,
  isLoaded: PropTypes.bool.isRequired,
  updateSetting: PropTypes.func.isRequired,
  usedAppointmentTypeIds: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default connect(mapStateToProps)(ApptTypeSelector)



// WEBPACK FOOTER //
// ./src/components/Settings/PostApptReviewMessageEditor/ApptTypeSelector.js